(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/wager/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/tur/wager/assets/javascripts/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs = svs || {};
(svs => {
  svs.tur.wager = _objectSpread(_objectSpread({}, svs.tur.wager), {}, {
    trackGA(wager) {
      if (wager.wagerId) {
        if (!svs.tur.wager.data) {
          svs.tur.wager.data = {};
        }
        svs.tur.wager.data.wagerid = wager.wagerId;
      }
      const items = [];
      _.each(wager.bets, item => {
        const trackingItem = new svs.components.analytics.transactionItem(item.productId, item.productName, item.price, item.numberOfRows, item.extraData);
        items.push(trackingItem);
      });
      const transaction = new svs.components.analytics.transaction(wager.wagerId, wager.totalPrice, items, 0, 0, undefined, wager.productName);
      svs.components.analytics.trackTransaction(transaction);
    },
    abortWager(abortWagerCallback) {
      svs.components.Storage.browser.remove('wagerstart', 'Wager', () => {
        svs.events.publish('/wager/paymentAborted');
        this.togglePayButton(true);
        if (abortWagerCallback && _.isFunction(abortWagerCallback)) {
          abortWagerCallback();
        }
      });
    },
    showNoMoneyMessage(balance, betAmount, abortCallback) {
      const syndicateName = Array.isArray(this.wagerprops) ? this.wagerprops[0].syndicateName : this.wagerprops.syndicateName;
      const isSyndicate = Boolean(syndicateName);
      const hasBalance = !_.isUndefined(balance);
      const hasCost = betAmount;
      const cost = hasCost ? svs.utils.format.Currency(betAmount) : null;
      balance = hasBalance ? svs.utils.format.Currency(balance) : null;
      const message = [];
      const actions = [];
      let title;
      if (isSyndicate) {
        title = "Bolaget ".concat(syndicateName, " har inte tillr\xE4ckligt med pengar f\xF6r att betala spelet.");
        actions.push({
          type: svs.components.dialog.button.SECONDARY,
          title: 'Ok',
          callback: () => {
            svs.components.Storage.browser.remove('wagerstart', 'Wager');
            this.togglePayButton(true);
            lowFundsDialog.close();
          }
        });
      } else {
        title = 'Du behöver sätta in pengar för att kunna betala ditt spel.';
        actions.push({
          type: svs.components.dialog.button.SECONDARY,
          title: 'Avbryt',
          callback: () => {
            svs.components.Storage.browser.remove('wagerstart', 'Wager');
            this.togglePayButton(true);
            lowFundsDialog.close();
            abortCallback && abortCallback();
          }
        });
        actions.push({
          type: svs.components.dialog.button.SECONDARY,
          title: 'Sätt in',
          callback: () => {
            lowFundsDialog.close();
            svs.components.Storage.browser.remove('wagerstart', 'Wager', () => {});
            svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
              returnUrl: window.location
            });
          }
        });
      }
      if (balance) {
        message.push({
          type: svs.components.dialog.message.TEXT,
          text: "Saldo: ".concat(svs.utils.format.Currency(balance), " kr"),
          align: svs.components.dialog.message.align.CENTER
        });
      }
      if (hasCost) {
        message.push({
          type: svs.components.dialog.message.TEXT,
          text: "Pris: ".concat(svs.utils.format.Currency(cost), " kr"),
          align: svs.components.dialog.message.align.CENTER
        });
      }
      const lowFundsDialog = new svs.components.dialog.Confirm({
        icon: 'deposit',
        branding: svs.components.dialog.branding.TUR,
        type: svs.components.dialog.type.DEFAULT,
        title,
        message,
        actions
      });
      svs.components.dialog.api.add(lowFundsDialog);
    },
    showSuspensionMessage() {
      const options = {
        method: 'GET',
        path: '/player/1/suspensions'
      };
      const errorFn = () => {
        svs.tur.wager.logger.error('Error fetching users suspensions');
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          type: svs.components.dialog.type.ERROR,
          title: 'Du har en spelpaus aktiv',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: "G\xE5 till <a href=\"".concat(svs.core.urlMapping.get('gamingResponsibilityPause'), "\">Spelpaus</a> f\xF6r att l\xE4sa mer.")
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok'
          }]
        }));
      };
      const successFn = response => {
        const activeSuspension = response.suspensions.filter(suspension => suspension.product === 'all' || suspension.product === 'quickGames');
        activeSuspension.forEach(suspension => {
          const to = dateFns.parseISO(suspension.validTo || suspension.terminable);
          const from = dateFns.parseISO(suspension.validFrom);
          if (dateFns.isValid(to) && dateFns.isValid(from)) {
            const duration = dateFns.differenceInMonths(to, from);
            suspension.duration = duration;
          }
        });
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          type: svs.components.dialog.type.ERROR,
          title: 'Du har en spelpaus aktiv',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: "G\xE5 till <a href=\"".concat(svs.core.urlMapping.get('gamingResponsibilityPause'), "\">Spelpaus</a> f\xF6r att l\xE4sa mer.")
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok'
          }]
        }));
      };
      svs.core.jupiter.call(options, successFn, errorFn);
    },
    isPaymentOngoing() {
      return svs.components.Storage.browser.get('wagerstart', 'Wager');
    },
    togglePayButton(on) {
      const payButton = $('.js-btn-pay');
      if (on) {
        payButton.prop('disabled', false);
      } else {
        payButton.prop('disabled', true);
      }
    },
    showKycMessage() {
      svs.core.module.load('/cl/components/kyc-messages', null, () => {
        svs.components.kyc_messages.showKYCMessage();
      });
    },
    async showErrorMessage(error) {
      const o = await svs.tur.apierrors.getErrorMessage(error);
      if (o.errorMessage && o.messageType !== svs.tur.apierrors.messageType.REGULAR) {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          type: svs.components.dialog.type.ERROR,
          title: o.errorTitle,
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: o.errorMessage
          }],
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok'
          }]
        }));
      }
    },
    handleError(errorCode, response) {
      let responseOut;
      switch (errorCode) {
        case 1019:
        case 5135:
          this.showSuspensionMessage();
          return;
        case 1006:
        case 6121:
          this.showNoMoneyMessage.call(this, this.balance);
          return;
        case 6332:
          this.showKycMessage();
          break;
        default:
          if (errorCode === 777) {
            responseOut = {
              regWagerResults: [{
                status: 'FAILURE',
                regWagerResult: null,
                error: {
                  code: errorCode
                }
              }]
            };
            this.error && this.error(responseOut);
          } else {
            responseOut = response;
            this.error && this.error(responseOut);
          }
      }
      this.showErrorMessage(response || errorCode);
      return responseOut;
    },
    confirmDialog(_ref) {
      let {
        isBag,
        isVoucher,
        isTicket,
        product,
        price,
        balance,
        isMultiple = false,
        cannotBeCancelled,
        confirmMessage,
        syndicateName = false,
        abortCallback
      } = _ref;
      if (syndicateName) {
        syndicateName = syndicateName.slice(-1) === 's' ? syndicateName : "".concat(syndicateName, "s");
      }
      const confirmDialog = new svs.components.dialog.Payment({
        branding: svs.components.dialog.branding.TUR,
        requireHandshake: true,
        icon: 'games',
        product,
        price,
        isVoucher,
        isTicket,
        isBag,
        message: confirmMessage || [{
          type: svs.components.dialog.message.TEXT,
          text: "".concat(cannotBeCancelled ? 'Observera att spelet inte' : 'Spelet', " g\xE5r att annullera."),
          align: svs.components.dialog.message.align.CENTER
        }, {
          type: svs.components.dialog.message.TEXT,
          text: "".concat(syndicateName ? syndicateName : 'Ditt', " saldo: ").concat(svs.utils.format.Currency(balance), " kr"),
          align: svs.components.dialog.message.align.CENTER
        }],
        actions: [{
          type: svs.components.dialog.button.SECONDARY,
          title: 'Avbryt',
          callback: () => {
            svs.components.Storage.browser.remove('wagerstart', 'Wager');
            this.togglePayButton(true);
            svs.tur.wager.data = {};
            svs.events.publish('/payment/cancel');
            confirmDialog.resolveHandshake();
            abortCallback && abortCallback();
          }
        }, {
          type: svs.components.dialog.button.PRIMARY,
          title: 'Betala',
          showLoader: true,
          callback: () => {
            if (isMultiple) {
              this.sendBagsWagers({
                callback: () => {
                  confirmDialog.resolveHandshake();
                }
              });
            } else {
              this.sendWager(() => {
                confirmDialog.resolveHandshake();
              });
            }
          }
        }]
      });
      setTimeout(() => {
        svs.components.dialog.api.add(confirmDialog);
      }, 10);
    },
    successDialog(data) {
      const message = [];
      const isSyndicateMode = svs.syndicate && svs.syndicate.AccountSelector && svs.syndicate.AccountSelector.getAccountModel().isSyndicateActive();
      const myBetsHomeParamUrl = "?grassrootstoasterredirect";
      const showDialog = () => {
        const completeDialog = new svs.components.dialog.Confirm({
          branding: svs.components.dialog.branding.TUR,
          icon: 'thumbs-up',
          title: 'Ditt spel är betalat. Lycka till!',
          allowDimmerClick: false,
          message,
          actions: [{
            type: svs.components.dialog.button.SECONDARY,
            title: 'Ok',
            callback: () => {
              completeDialog.close();
              this.success && this.success(data);
            }
          }]
        });
        svs.components.dialog.api.add(completeDialog);
      };
      if (isSyndicateMode) {
        const syndicateLink = svs.core.urlMapping.get('playTogetherTeam').replace(':id', svs.syndicate.AccountSelector.getAccountModel().get('syndicateId')) + myBetsHomeParamUrl;
        message.push({
          type: svs.components.dialog.message.TEXT,
          text: "Du hittar ditt spel under <a class=\"alert-text-link\" href=\"".concat(syndicateLink, "\">Spela tillsammans</a>\n            och <a class=\"alert-text-link\" href=\"").concat(svs.core.urlMapping.get('myBetsHome')).concat(myBetsHomeParamUrl, "\">Mina spel</a>."),
          align: svs.components.dialog.message.align.CENTER
        });
        if (this.extraSuccessMessage) {
          message.push({
            type: svs.components.dialog.message.TEXT,
            text: this.extraSuccessMessage,
            align: svs.components.dialog.message.align.CENTER
          });
        }
        showDialog();
      } else if (data.requestInfo && data.requestInfo.dataSource === 'JunoVoucher') {
        this.success && this.success(data);
      } else {
        message.push({
          type: svs.components.dialog.message.TEXT,
          text: "Se dina lagda spel i <a href=\"".concat(svs.core.urlMapping.get('myBetsHome')).concat(myBetsHomeParamUrl, "\" class=\"alert-text-link\">Mina spel</a>."),
          align: svs.components.dialog.message.align.CENTER
        });
        if (this.extraSuccessMessage) {
          message.push({
            type: svs.components.dialog.message.TEXT,
            text: this.extraSuccessMessage,
            align: svs.components.dialog.message.align.CENTER
          });
        }
        $.when(svs.tur.usersettings.get({
          key: 'receivers'
        })).done(_ref2 => {
          let {
            value
          } = _ref2;
          if (value) {
            let sponsors = '';
            for (let i = 0; i < value.length; i++) {
              if (i > 0) {
                if (i === value.length - 1) {
                  sponsors += ' och ';
                } else {
                  sponsors += ', ';
                }
              }
              sponsors += value[i];
            }
            if (sponsors) {
              message.push({
                type: svs.components.dialog.message.TEXT,
                text: "".concat(sponsors, " tackar f\xF6r ditt st\xF6d genom Gr\xE4sroten!"),
                align: svs.components.dialog.message.align.CENTER
              });
            }
          }
          showDialog();
        }).catch(error => {
          svs.tur.wager.logger.warn(error);
          showDialog();
        });
      }
    }
  });
})(svs);

 })(window);